import * as React from 'react'
import { useIntl } from 'react-intl'
import styled from '@emotion/styled'
import Button from '@mui/material/Button'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogContentText from '@mui/material/DialogContentText'
import DialogTitle from '@mui/material/DialogTitle'
import { Box, IconButton, Tooltip } from '@mui/material'
import LockIcon from '../../assets/icons/Lock.svg'

const styles = {
    tempPasswordBox: {
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        background: '#E0E2E7',
        borderRadius: '20px',
        padding: '4px 16px',
        width: 'fit-content',
    },
    usedPassword: {
        color: '#858D9D',
        cursor: 'default',
    },
}

interface Props {
    fullName: string
    password: string
    isLoading?: boolean
    confirmAction: () => void
}

const ResetTemporaryPassword: React.FC<Props> = ({
    fullName,
    password = '',
    confirmAction,
    isLoading = false,
}) => {
    const { formatMessage } = useIntl()
    const [open, setOpen] = React.useState(false)

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
    }

    return (
        <Box sx={{ ml: 1 }}>
            <Box sx={styles.tempPasswordBox}>
                {/* Пароль обнуляется, как только студент сменил его сам -
                    пустая ячейка выглядела бы как отсутствие данных */}
                {password ? (
                    password
                ) : (
                    <Tooltip
                        placement="top"
                        title={formatMessage({ id: 'tempPasswordUsed' })}
                    >
                        <Box
                            component="span"
                            sx={styles.usedPassword}
                        >
                            —
                        </Box>
                    </Tooltip>
                )}

                <IconLockButton
                    disabled={isLoading}
                    onClick={() => handleClickOpen()}
                >
                    <img
                        src={LockIcon}
                        alt="edit"
                    />
                </IconLockButton>
            </Box>

            <Dialog
                maxWidth={'sm'}
                fullWidth
                open={open}
                onClose={handleClose}
            >
                <DialogTitle id="responsive-dialog-title">
                    {formatMessage({ id: 'payAttention' })}
                </DialogTitle>

                <DialogContent>
                    <DialogContentText>
                        {formatMessage(
                            { id: 'resetPasswordConfirmText' },
                            { value: fullName },
                        )}
                    </DialogContentText>
                </DialogContent>

                <DialogActions sx={{ m: 2 }}>
                    <Button onClick={handleClose}>
                        {formatMessage({ id: 'cancel' })}
                    </Button>

                    <Button
                        variant="contained"
                        onClick={() => {
                            confirmAction()
                            handleClose()
                        }}
                    >
                        {formatMessage({ id: 'yes' })}
                    </Button>
                </DialogActions>
            </Dialog>
        </Box>
    )
}

export default ResetTemporaryPassword

const IconLockButton = styled(IconButton)`
    display: flex;
    gap: 4px;
    background: #f3f4f5;
    border-radius: 10px;
    padding: 4px 8px;
    width: fit-content;
`
